import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {OrderService} from './order.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-popup-order',
  templateUrl: './popup-order.component.html',
  styleUrls: ['./popup-order.component.scss']
})
export class PopupOrderComponent implements OnInit {
  orderForm: FormGroup;
  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder, private orderService: OrderService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.initForm();
  }
  get f() { return this.orderForm.controls; }
  initForm() {
    this.orderForm = this.formBuilder.group({
      name: ['', Validators.required],
      number: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      adress: ['', [Validators.required]],
      home: ['', [Validators.required]],
      apartment: ['', [Validators.required]],
    });
  }
  order() {
    /*let to = 'sale@lift46.ru';*/
    const to = 'request@octopus-online.ru';
    const from = this.f.email.value;
    /*let from = 'this.form.value.email'*/
    if (this.orderForm.valid) {
      console.log('form: ', this.orderForm);
      const params = {
        to,
        from,
        replyTo: this.f.email.value,
        subject: 'Новая заявка с сайта octopus-online.ru',
        html: `<p>Новая заявка на подключение отправлена с сайта&nbsp;
<strong><span><a href="http://octopus-online.ru" target="_blank">octopus-online.ru</a>
</span></strong></p>
<p><strong><em><span>Контактные данные пользователя:</span></em></strong></p>
<p><strong><span>Имя: ${this.f.name.value}</span></strong></p>
<p><strong><span>Телефон: ${this.f.number.value}</span></strong></p>
<p><strong><span>Email: <a href="http://mailto:${this.f.email.value}">${this.f.email.value}</a>&nbsp;</span></strong></p>
<p><strong><span>Дополнительная информация: адрес: ${this.f.adress.value}, дом: ${this.f.home.value}, квартира: ${this.f.apartment.value}</span></strong></p>
<p><strong><span>Перезвоните для уточнения информации!</span></strong></p>
`
      };
      console.log(params);
      this.orderService.sendMail(params)
        .pipe()
        .subscribe(
          result => {
            console.log(result);
            this.toastr.success('Заявка успешно отправлена');
            this.activeModal.close();
          },
          (error) => {
            console.log(error);
            this.toastr.error('Произошла ошибка, перезвоните по номеру который указан на сайте');
            this.activeModal.close();
          });
    }

  }
}
